export default __webpack_public_path__ + "static/media/discord-chat-dark.4ba3e891.png";